import * as React from 'react'
import { cn } from '~/lib/utils'

export type InputProps = React.ComponentProps<'input'>

/** 텍스트 입력. 시맨틱 토큰 색·반경을 사용한다. */
function Input({ className, type = 'text', ref, ...props }: InputProps) {
    return (
        <input
            ref={ref}
            type={type}
            data-slot='input'
            className={cn(
                'border-input bg-card text-foreground h-10 w-full rounded-md border px-3 text-sm transition-colors',
                'placeholder:text-muted-foreground',
                'focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-none',
                'disabled:cursor-not-allowed disabled:opacity-50',
                className
            )}
            {...props}
        />
    )
}

export { Input }
